export enum GridWallStatusEnum {
    PUBLISHED = 'PUBLISHED',
    UNPUBLISHED = 'UNPUBLISHED',
}

export enum GridWallAccessEnum {
    PRIVATE = 'PRIVATE',
    PUBLIC = 'PUBLIC',
}

export enum GridwallFrequencyEnum {
    MIN_1 = 1,
    MIN_5 = 5,
    MIN_10 = 10,
    MIN_15 = 15,
    MIN_20 = 20,
    MIN_30 = 30,
    MIN_60 = 60,
    MIN_120 = 120,
}
